import React from 'react';
import SVGIcon from '../components/SVGIcon/SVGIcon';
import {
  WidgetsList,
  WidgetsListItem,
  WidgetsListItemCard
} from '../components/WidgetList/WidgetList.style';
import { Body } from '../styled components/Typography';
import { UIBar, UIBarGrowItem } from '../styled components/UIBar';
import { listViewTitle } from '../libs/listViewSettings';
import type { ListViewConfiguration } from './types';

interface ListViewOverviewProps {
  /** In the order they are offered in */
  views: ListViewConfiguration[];
  /** The address of a view's own page. Every entry is a real link to it, so it
   *  can be reached with the keyboard and opened in a new tab */
  hrefForView: (view: ListViewConfiguration) => string;
  /** Opens a view within the app, in place of following the link */
  onOpenView: (view: ListViewConfiguration) => void;
}

/**
 * The views a tenant has configured, for picking the one to open. Laid out like
 * the widgets on the home page, which is where the user has just come from.
 */
const ListViewOverview = ({ views, hrefForView, onOpenView }: ListViewOverviewProps) => (
  <WidgetsList data-test-type="listViewOverview">
    {views.map((view) => (
      <WidgetsListItem key={view.id}>
        <WidgetsListItemCard
          href={hrefForView(view)}
          onClick={(event: React.MouseEvent) => {
            /* A modified click is the browser's to handle: a new tab or window */
            if (event.metaKey || event.ctrlKey || event.shiftKey) return;
            event.preventDefault();
            onOpenView(view);
          }}
          data-test-list-view-id={view.id}
        >
          <UIBar tw="pl-4 pr-4">
            <div tw="truncate">
              <Body as="span" $color="black">
                {listViewTitle(view)}
              </Body>
            </div>
            <UIBarGrowItem />
            {/* The chevron the home page shows in a small icon button, drawn
                without one: a button cannot be nested inside a link */}
            <span tw="inline-flex p-4 text-black text-opacity-60">
              <SVGIcon icon="navigate-next" size="medium" />
            </span>
          </UIBar>
        </WidgetsListItemCard>
      </WidgetsListItem>
    ))}
  </WidgetsList>
);

export default ListViewOverview;
